"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cache_1 = require("@almservices-cl/cache");
class TraineeList {
    constructor(strategy, api) {
        this.strategy = strategy;
        this.api = api;
        this.getTraineeList = (application) => {
            const observable = new cache_1.Observable();
            this.strategy
                .get("TraineeList", async () => {
                return this.api.getMembersList(application);
            }, [])
                .then((result) => {
                observable.setValue(result);
            });
            return observable;
        };
    }
}
exports.default = TraineeList;
//# sourceMappingURL=TraineeList.js.map